import React from 'react';
const Emailhosting = () => {
  return(
<>
    <div className="bg">
        <div className="container">
            <h1 className="fs-1 text-center pt-5">Email Hosting</h1>
            <p className="text-center">Put your business online or blog about the latest memes. This one size fits all web hosting package is the perfect place to start. Our 24/7 managed support and straight forward pricing is why customers choose to stay with us for life.</p>
            <div className="row mt-5">
                <div className="col-md-4">
                    <ul>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Your@name.com</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Unlimited Storage</li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <ul>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Unlimited Devices</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Private and Secure</li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <ul>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; SPAM & Virus Protection</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; 24/7 Technical Support</li>
                    </ul>
                </div>
            </div>
            <h1 className="fs-1 text-center pt-5">Supported Devices</h1>
            <p className="text-center">Our unique solutions and expertise guarantee a superior experience!</p>

            <div className="row mt-5">
                <div className="col-md-3">
                    <div className="shadow  p-5">
                        <div className ="text-center">
                            <img src="https://www.interserver.net/webhosting/assets/images/email-hosting/ios.png" className="p-3 w-50"/>
                            <p className="fs-4 fw-bold text-center">IOS</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="shadow  p-5">
                        <div className ="text-center">
                            <img src="https://www.interserver.net/webhosting/assets/images/email-hosting/android.png" className="p-3 w-50"/>
                            <p className="fs-4 fw-bold text-center">Android</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="shadow  p-5">
                        <div className ="text-center">
                            <img src="https://www.interserver.net/webhosting/assets/images/email-hosting/windows.png" className="p-3 w-50"/>
                            <p className="fs-4 fw-bold text-center">Windows</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="shadow  p-5">
                        <div className ="text-center">
                            <img src="https://www.interserver.net/webhosting/assets/images/email-hosting/mac.png" className="p-3 w-50"/>
                            <p className="fs-4 fw-bold text-center">MAC</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="shadow p-5 mt-5 mb-5">
                <div className="row ">
                    <div className="col-md-9 align-self-center">
                        <p className="fs-1 fw-bold"><span className="color">Email Hosting</span> Service Provider</p>
                    </div>
                    <div className="col-md-3 align-self-center">
                    <button type="submit" class="insuba-btn text-center fs-5  p-3 w-100"><a href="Contactform" className='text-white text-center'>Sign up Now</a></button>
                    </div>
                </div>
            </div>
            <h1 className="fs-1 text-center pt-5">Affordable Email Hosting</h1>
            <div className="row mt-5">
                <div className="col-md-4 mt-5">
                    <p className="fs-5 fw-bold">Web Site Included</p>
                    <p>Along with email you will have all the features that come with our Cloud Web Hosting package. Build a site using our Website Builder or install WordPress.</p>
                </div>
                <div className="col-md-4 mt-5">
                    <p className="fs-5 fw-bold">End-to-End Encryption</p>
                    <p>Automatic Email Security All emails are secured automatically with end-to-end encryption. This means even we cannot decrypt and read your emails. As a result, your encrypted emails cannot be shared with third parties.</p>
                </div>
                <div className="col-md-4 mt-5">
                    <p className="fs-5 fw-bold">Anonymous Email</p>
                    <p>Protect Your Privacy No personal information is required to create your secure email account. By default, we do not keep any IP logs which can be linked to your anonymous email account. Your privacy comes first.</p>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-md-4 mt-5">
                    <p className="fs-5 fw-bold">Open Source</p>
                    <p>Free Secure Email We believe email privacy should be available to all. That's why our code is open source and basic.</p>
                </div>
                <div className="col-md-4 mt-5">
                    <p className="fs-5 fw-bold">Easy to Use</p>
                    <p>Security without the hassle Email can be used on any device without software install. Interserver secure email accounts are fully compatible with other email providers. You can send and receive emails normally.</p>
                </div>
                <div className="col-md-4 mt-5">
                    <p className="fs-5 fw-bold">Brute-Force Protection</p>
                    <p>As a business email hosting provider we take care of all attacks against your email boxes and we will block any malicious activity or people trying to compromise your account.</p>
                </div>
            </div>
        </div>
    </div>
</>
    );
};
 
export default Emailhosting;